/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { SearchCriteria } from '../SearchCriteria';
import { ChartFilter } from '../ChartComponents';
import { DrillDownType } from '../DrillDownType';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import FolderOpenOutlinedIcon from '@material-ui/icons/FolderOpenOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
    }),
);

export enum SalesPipelineOptionEnum {
    ESTIMATED_FEES = 0,
    PIPELINE,
}
interface CostAgreementsChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
}

interface ChartState {
    totalCounts: number;
    groupings: string[];
    formats: string[];
    mattersCount: number[];
}

export const CostAgreementsChart: React.FC<CostAgreementsChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const constAgreementsQuery = useQuery<CostAgreementsOutstandingData, CostAgreementsOutstandingParams>(COST_AGREEMENTS_OUTSTANDING_QUERY, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'cache-and-network',
    });

    const [state, setState] = useState<ChartState>({
        groupings: [],
        formats: [],
        mattersCount: [],
        totalCounts: 0,
    });

    useEffect(() => {
        if (
            constAgreementsQuery.data &&
            constAgreementsQuery.data.statistics &&
            constAgreementsQuery.data.statistics.matter &&
            constAgreementsQuery.data.statistics.matter.costAgreementOutstanding &&
            !constAgreementsQuery.error &&
            !constAgreementsQuery.loading
        ) {
            setState((prevState) => {
                const { costAgreement, total } = constAgreementsQuery.data!.statistics.matter.costAgreementOutstanding;
                return {
                    ...prevState,
                    totalCounts: total,
                    groupings: costAgreement.map((overview: CostAgreement) => overview.grouping),
                    formats: costAgreement.map((overview: CostAgreement) => overview.format),
                    mattersCount: costAgreement.map((overview: CostAgreement) => overview.matters),
                };
            });
        }
        // tslint:disable-next-line: align
    }, [constAgreementsQuery.data, constAgreementsQuery.error, constAgreementsQuery.loading]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isCostAgreementsChartOpen`);
        }
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push({ property: 'CostAgreement', operator: '', comparison: '' });

            props.getSelectedItem(searchCriterias, true, `Cost Agreements Outstanding`, DrillDownType.matterSummaryDrilldown, 'Cost Agreements');
        }
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    if (constAgreementsQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    const mattersCounts = state.mattersCount.map((matters: number) => matters);

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(mattersCounts) ? ' rv-chart--empty' : ''}`}>
            <IconButtonWrapper aria-label="close">
                <ChartInfo 
                    description={props.description}
                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                    className={`${classes.helpIcon} rv-chart-help`}
                />
                <IconButton aria-label="close" onClick={onCloseChart} size="small">
                    <CloseIcon className={classes.closeIcon} />
                </IconButton>
            </IconButtonWrapper>
            <div className={classes.titleContainer}>
                <ChartHeading icon={<FolderOpenOutlinedIcon />} title="Cost Agreements Outstanding" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.totalCounts} format={(amount) => `${formatNumber(amount)}`} />
                </div>
            </div>
            <div className={classes.barContainer}>
                <Bar
                    ref={chartRef}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const grouping = state.groupings[_index];

                            const searchCriterias = new Array<SearchCriteria>();
                            searchCriterias.push(
                                {
                                    property: 'CostAgreement',
                                    operator: '',
                                    comparison: grouping
                                }
                            );

                            props.getSelectedItem(
                                searchCriterias,
                                true,
                                `Cost Agreements Outstanding`,
                                DrillDownType.matterSummaryDrilldown,
                                'Cost Agreements'
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(state.formats),
                        datasets: [
                            {
                                label: 'Matters',
                                ...rvBarDatasetStyle([RV_CHART_COLORS.red, RV_CHART_COLORS.amber, RV_CHART_COLORS.primary, RV_CHART_COLORS.primarySoft]),
                                // tslint:disable-next-line: radix
                                data: mattersCounts,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(mattersCounts),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(mattersCounts),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                // min: 0,
                                // max: 9 // minimum display
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: false,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: false,
                                    },
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return `${dataset.label}: ${formatNumber(currentValue)}`;
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(mattersCounts) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            {/* <span className={classes.span}>{formatNumber(state.openEnquiryCount)} open enquiries have no Fee Estimate</span> */}
            {/* <span className={classes.span}>Drill down to timekeeper details</span>     
            <span className={classes.span}>The top 10 timekeepers are shown</span>                           */}
        </div>
    );
};

export interface CostAgreementsOutstandingParams {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
}

export interface CostAgreementsOutstandingData {
    statistics: Statistics;
}

export interface Statistics {
    matter: Matter;
}

export interface Matter {
    costAgreementOutstanding: CostAgreementOutstanding;
}

export interface CostAgreementOutstanding {
    costAgreement: CostAgreement[];
    total: number;
}

export interface CostAgreement {
    matters: number;
    grouping: string;
    format: string;
}

const COST_AGREEMENTS_OUTSTANDING_QUERY = gql`
    query CostAgreementOutstanding($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics {
            matter {
                costAgreementOutstanding(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                    costAgreement {
                        matters
                        grouping
                        format
                    }
                    total
                }
            }
        }
    }
`;
